var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showLoader)?_c('div',{staticClass:"loader"},[_c('CSpinner',{staticStyle:{"width":"3rem","height":"3rem"},attrs:{"color":"primary"}})],1):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }